import { REACTION_EMOJIS, ReactionEmoji } from '@mesa/core/reactions';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ReactionPickerProps {
  onEmojiSelect: (emoji: ReactionEmoji) => void;
  disabled?: boolean;
  className?: string;
}

export function ReactionPicker({ onEmojiSelect, disabled = false, className }: ReactionPickerProps) {
  return (
    <div className={cn('grid grid-cols-4 gap-1 p-2', className)}>
      {REACTION_EMOJIS.map((emoji) => (
        <Button
          key={emoji}
          variant="ghost"
          size="sm"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            onEmojiSelect(emoji);
          }}
          disabled={disabled}
          className={cn(
            'h-8 w-8 p-0 hover:bg-gray-100 transition-colors',
            'flex items-center justify-center',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
        >
          <span className="text-lg leading-none">{emoji}</span>
        </Button>
      ))}
    </div>
  );
}
